export interface Volume {
  code: string
  name: string
  count: string
  intro: string[]
  solves: string
  result: string
}

export const volumes: Volume[] = [
  {
    code: '01',
    name: 'Fondamenti e Prime Sedute',
    count: '16 sessioni pratiche',
    intro: [
      'Costruisci le basi del gioco attraverso posizione pronta, lettura della traiettoria, movimento, bagher, palleggio, comunicazione e primi collegamenti tra giocatori.',
      'Ogni gesto viene mostrato attraverso sequenze visuali, posizioni del corpo, traiettorie, frecce, errori/correzioni e diagrammi di campo.',
    ],
    solves:
      'Giocatori che arrivano male sulla palla, piattaforma instabile, difficoltà nel controllo, poca comunicazione e fondamentali ancora poco consolidati.',
    result:
      'Hai una progressione chiara per costruire le basi e 16 sedute già organizzate per trasformare i fondamentali in gioco.',
  },
  {
    code: '02',
    name: 'Servizio e Ricezione',
    count: '16 sessioni pratiche',
    intro: [
      'Costruisci il servizio dalle basi fino a obiettivi, zone e pressione progressiva.',
      'Organizza la ricezione attraverso posizione iniziale, lettura della traiettoria, spostamento, controllo e comunicazione tra ricevitori.',
    ],
    solves:
      'Servizi senza controllo, ricezione instabile, giocatori immobili sulla traiettoria e confusione sulle zone di competenza.',
    result:
      'Il servizio diventa intenzionale e la ricezione più organizzata, leggibile e collaborativa.',
  },
  {
    code: '03',
    name: 'Attacco e Rincorsa',
    count: '16 sessioni pratiche',
    intro: [
      "Sviluppa rincorsa, ritmo, stacco, coordinazione braccio-corpo, punto di contatto e direzione dell'attacco attraverso progressioni visuali.",
    ],
    solves:
      'Rincorse fuori tempo, stacco poco efficace, contatto basso, perdita di equilibrio e attacchi senza direzione.',
    result:
      "I giocatori comprendono visivamente la sequenza dell'attacco e imparano a collegare rincorsa, salto e contatto.",
  },
  {
    code: '04',
    name: 'Muro e Difesa',
    count: '16 sessioni pratiche',
    intro: [
      'Organizza posizione, lettura, spostamento, salto a muro, posizionamento difensivo e transizione dopo il primo contatto.',
    ],
    solves:
      'Muro in ritardo, mani poco efficaci, difensori fuori posizione e poca connessione tra muro e seconda linea.',
    result:
      'La squadra inizia a difendere come un sistema invece che come giocatori isolati.',
  },
  {
    code: '05',
    name: 'Costruzione del Gioco',
    count: '16 sessioni pratiche',
    intro: [
      'Collega ricezione, alzata, attacco, copertura e transizione attraverso esercizi progressivi da 2, 3, 4 e 6 giocatori.',
    ],
    solves:
      'Buoni fondamentali individuali che scompaiono appena inizia il gioco reale.',
    result:
      'I giocatori imparano a collegare i tocchi e a trasformare la tecnica in continuità di squadra.',
  },
  {
    code: '06',
    name: 'Sistemi, Gruppi e Pianificazione',
    count: '16 sessioni integrate',
    intro: [
      "Organizza gruppi di livelli diversi, rotazioni, stazioni, mini-campi, progressioni simultanee e pianificazione dell'allenamento.",
    ],
    solves:
      'Giocatori fermi, tempi morti, gruppi disordinati e difficoltà nel gestire livelli differenti nello stesso allenamento.',
    result:
      'Più giocatori attivi, meno caos e una struttura più chiara dall’inizio alla fine della seduta.',
  },
]
